import React from "react";
import { Controller } from "react-hook-form";
import { Col, Input, Label, Row } from "reactstrap";
import ValidationMsgComponent from "../ValidationMsgComponent";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import "./index.css";

interface ControlledTextFieldProps {
  label?: string;
  inputName: string;
  inputType: string;
  placeholder?: string;
  invalid?: boolean;
  control: any;
  rules?: object;
  errors?: { [key: string]: any };
  register?: any;
  isRequired?: boolean;
  hasSideLabel?: boolean;
  sideLabel?: string;
  isDisabled?: boolean;
  defaultValue?: string;
  className?: string;
  value?: string | FileList;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  multiple?: boolean;
  setShowModal: (show: boolean) => void;
}
type MyInputType =
  | "text"
  | "email"
  | "password"
  | "number"
  | "tel"
  | "url"
  | "search"
  | "date"
  | "datetime-local"
  | "time"
  | "week"
  | "month"
  | "color"
  | "file";

const ControlledRowTextFieldAddress: React.FC<ControlledTextFieldProps> = ({
  label,
  inputName,
  inputType,
  placeholder,
  invalid,
  control,
  rules,
  errors,
  register,
  isRequired,
  hasSideLabel,
  sideLabel,
  isDisabled,
  defaultValue,
  className,
  onChange,
  setShowModal,
}) => {
  return (
    <div className="my-1">
      <Row>
        <Col lg="4">
          <Label className={`pt-1 form-label`} htmlFor={inputName}>
            {isRequired ? `${label} ` : label}
          </Label>
        </Col>
        <Col lg="7">
          <Controller
            name={inputName}
            control={control}
            rules={rules}
            render={({ field }) => (
              <Input
                id={inputName}
                type={inputType as MyInputType}
                placeholder={placeholder}
                invalid={invalid || (errors && errors[inputName])} 
                disabled={true}
                {...field}
                defaultValue={defaultValue}
                className={className}
                required={isRequired}
                step={inputType === "number" ? "any" : undefined}
                multiple={inputType === "file" ? true : undefined}
                onChange={(e) => {
                  field.onChange(e);
                  if (onChange) {
                    onChange(e);
                  }
                }}
              />
            )}
          />
          {errors && errors[inputName] && ( 
            <ValidationMsgComponent
              inputName={inputName}
              invalid={invalid}
              errors={errors}
              rules={rules}
            />
          )}
          {hasSideLabel && <span className="ps-1 me-1">{sideLabel}</span>}
          {invalid && (
            <ValidationMsgComponent
              inputName={inputName}
              invalid={invalid}
              errors={errors}
              rules={rules}
            />
          )}
        </Col>
        <Col lg="1">
          <Button
            className="add-restaurant-location-add-button"
            variant="light"
            color="#590B21"
            type="button"
            onClick={() => setShowModal(true)}
            disabled={isDisabled}
          >
            <FontAwesomeIcon icon={faMapMarkerAlt} />
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default ControlledRowTextFieldAddress;